import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

const IconStripe = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge('h-[17px] w-3', className)}
    {...props}
  >
    <path
      d="M4.7811 5.06264C4.7811 4.33407 5.38583 4.05385 6.3874 4.05385C7.72627 4.05385 9.39359 4.42724 10.777 5.09836C10.9128 5.16426 11.074 5.06711 11.074 4.91613V0.995626C11.074 0.913407 11.0237 0.8394 10.9469 0.810163C9.42172 0.229905 7.91351 0 6.3874 0C2.55118 0 0 1.98022 0 5.28681C0 10.4429 7.1811 9.62088 7.1811 11.844C7.1811 12.7033 6.4252 12.9835 5.36693 12.9835C3.89485 12.9835 2.03994 12.4241 0.505165 11.6449C0.370049 11.5763 0.207874 11.6732 0.207874 11.8247V15.8029C0.207874 15.8831 0.255825 15.9557 0.329946 15.9864C2.04751 16.697 3.77935 17 5.36693 17C9.29764 17 12 15.0758 12 11.7319C11.9811 6.16484 4.7811 7.15495 4.7811 5.06264Z"
      fill="currentColor"
    />
  </svg>
);

export default IconStripe;
